const translations = {
    invoiceManagement: "ניהול חשבוניות",
    confirmDeletion: "אישור מחיקה",
    deleteConfirmation: "האם אתה בטוח שברצונך למחוק חשבונית זו?",
    cancel: "ביטול",
    delete: "מחק",
    download: "הורדה",
    id: "מזהה",
    supplierName: "שם ספק",
    date: "תאריך",
    amount: "סכום",
    uploadedInvoices: "חשבוניות שהועלו",
    invoicesByStatus: "חשבוניות לפי סטטוס",
    uploadInvoices: "העלה חשבוניות",
    dragAndDropPrompt: "גרירת קבצים לכאן או לחיצה לבחירה",
    pendingFiles: "קבצים ממתינים להעלאה",
    uploading: "מעלה...",
    uploadToServer: "העלה לשרת",
    uploadSuccess: "הקבצים הועלו בהצלחה",
    uploadError: "שגיאה בהעלאת הקבצים",
    successfullyUploadedFiles: "קבצים שהועלו בהצלחה",
    supportedFormats: "PDF, JPEG, או PNG"
  };
  
  export default translations;